module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Acknowledgments"
    }
  }, [_c('p', {
    staticClass: "fm_h",
    attrs: {
      "id": "sec1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rsec1"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_vm._v("The list of people who deserve my gratitude seems endless, and some (like Ernst Stromer) have been dead for decades and never even met me! I thank Thomas Bastelberge, Oliver Demuth, Liz Kennedy, Casey Holliday, Bruno Granier, Walid Makled, Marguerite Miller, Emilie Läng, Omar Mohamed, Thomas Tütken, Olof Moleman, Markus Buhler, Ricardo Pimentel, Guillaume Guinot, Michael Donovan, Jean-François Lhomme, Neil Loneragan, Andrea Cau, Daniela Schwarz-Wings, Didier Dutheil, Mike Taylor, John Adamek, Matt Lamanna, Hilda Silva, Cristiano Dal Sasso, Wagih Hannaa, Mickey Mortimer, Aaron Miller, Lionel Cavin, Hans Larsson, Bradley McFeeters, and Kenneth Lacovara for their assistance in providing me with access to literature and specimens. If I’ve missed anyone from that list, no slight was ever intended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Worthy of special mention are the staff of Liverpool John Moores University for their continued patronage and advice. My editor James Farlow and principal reviewer Barbara Grandstaff, who share many of the same interests and sparked many new ideas through our discussions. My thanks are also extended to my former flatmates, whose friendship at university made that period one of the happiest points of my life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("I would also like to thank Joschua Knüppe, Christopher DiPiazza, Andrey Atuchin, and James McKay for contributing artwork and ideas during the writing of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("And ultimately, I’ve got to thank my sister and aunt for their continued love and support."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04a22060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Acknowledgments.vue
// module id = 78
// module chunks = 0